'use client'
import NoResultsIcon from 'components/svg/searchIcons/noResults';
import styles from './NoResults.module.css';
import buttons from "components/_styled/buttons.module.css";
import Link from "next/link";
import { useState } from "react";
import SearchInput from "../CategorySearch/search";

type props = {
    forSale: boolean,
    recommendations: [],
    locationDetails: locationDetailsProps
}

type locationDetailsProps = {
    name: string
}

interface Group {
    [key: string]: {
        to: string,
        uri: string,
        name: string,
        id: number
    }[]
}

const NoResults = ({ locationDetails, recommendations, forSale = false }: props) => {
    const [showAll, setShowAll] = useState(false);

    const groupByCategory = recommendations?.reduce<Group>((group, recommendation) => {
        const { to } = recommendation;
        group[to] = group[to] ?? [];
        group[to].push(recommendation);
        return group;
    }, {});

    const length = groupByCategory ? Object.keys(groupByCategory).length : 0;

    return (
        <div className={styles.NoResultsContainer}>
            <NoResultsIcon />
            <h1>No results found</h1>
            <p>Sorry! We don’t currently have any shops {forSale ? 'for sale' : 'to rent'} in {locationDetails.name}.</p>
            {length > 0 && (
                <p>Try searching in one of the nearby areas below</p>
            )}

            {length === 0 && (
                <div className={styles.searchContainer}>
                    <SearchInput nameLookUp={false} forSale={false} categoryUrl={'shops-to-rent'} type={'PROPERTY'} category={'ALL'} placeholder={'Begin typing the name of the shops for rent'} />
                </div>
            )}




            <div className={styles.container} style={{ gridTemplateColumns: ` repeat(${length > 4 ? 4 : length}, 1fr)` }}>
                {groupByCategory && Object.keys(groupByCategory).slice(0, showAll ? length : 4).map((id) => {
                    let data = groupByCategory[id];
                    let townLength = data.length;
                    return (
                        <div key={id}>
                            <h2>{`Locations within ${id} miles of ${locationDetails.name}`}</h2>
                            <ul id={`locationList${id}`} className={townLength > 3 ? 'hideOverflow' : ''}>
                                {data.map((group) => (
                                    <li key={group.id}>
                                        <Link href={`/${forSale ? 'shops-for-sale' : 'shops-to-rent'}/${group.uri}`} passHref prefetch={false} legacyBehavior>
                                            <a className={buttons.primaryButton}>Shops {forSale ? 'for sale' : 'for rent'}  in {group.name}</a>
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                            {townLength > 4 && (
                                <button id={`locationListButton${id}`} onClick={() => {
                                    let list = document.getElementById(`locationList${id}`);
                                    let button = document.getElementById(`locationListButton${id}`);
                                    if (list && button) {
                                        if (list?.classList.contains(styles.hideOverflow)) {
                                            list?.classList.remove(styles.hideOverflow);
                                            button.innerHTML = "View less"
                                        } else {
                                            list?.classList.add(styles.hideOverflow)
                                            button.innerHTML = `View ${townLength - 3} more`
                                        }
                                    }

                                }} className={styles.viewMore}>
                                    View {townLength - 3} more
                                </button>
                            )
                            }
                        </div>)
                })}
            </div>
            {length > 4 && (
                <button className={buttons.primaryButton} onClick={() => {
                    setShowAll(!showAll);
                }}>{`Show ${showAll ? "fewer" : "more"} locations`}</button>
            )}

        </div >
    )
}

export default NoResults;